// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// 👇 Replace this with your Firebase project’s config
const firebaseConfig = {
  apiKey: "AIzaSyDyRc2AscDSrF6GMTmVHaVcAIV2RyPtxCo",
  authDomain: "driveeasy-partner.firebaseapp.com",
  projectId: "driveeasy-partner",
  storageBucket: "driveeasy-partner.firebasestorage.app",
  messagingSenderId: "904892438797",
  appId: "1:904892438797:web:2b44e82786749ee3cbb844",
  measurementId: "G-YW27KNHHM0"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Firestore database instance
export const db = getFirestore(app);

// Authentication instance (for login later)
export const auth = getAuth(app);

export const storage = getStorage(app);

